import { render, staticRenderFns } from "./transfer-coin-modal.vue?vue&type=template&id=f3c7a1a4&scoped=true"
import script from "./transfer-coin-modal.vue?vue&type=script&lang=js"
export * from "./transfer-coin-modal.vue?vue&type=script&lang=js"
import style0 from "./transfer-coin-modal.vue?vue&type=style&index=0&id=f3c7a1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c7a1a4",
  null
  
)

export default component.exports